import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { ColumnExportButton, Table } from 'barnyard/components';
import AlertItem from './AlertItem';
import { format_dollars } from '~/app/common/utils';


const { CellRenderers } = Table;

const columns = [{
  Header: 'Vetcove ID',
  accessor: 'id',
}, {
  Header: 'Date',
  id: 'date',
  accessor: row => CellRenderers.renderDate({ value: row.date })
}, {
  Header: 'Order #',
  accessor: 'number',
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Shipping',
  id: 'shipping',
  accessor: row => format_dollars({ integer: row.shipping, include_cents: true })
}, {
  Header: 'Link',
  accessor: 'id',
  Cell: ({ value }) => (/* eslint-disable-line react/prop-types */
    <Link to={`/corporate/invoices/invoices/${value}`}>View Invoice</Link>
  ),
  includeInExport: false
}];

class ShippingFeesAlert extends Component {
  render() {
    const { alert } = this.props;

    return (
      <AlertItem
        alert={alert}
        date={moment(alert.date).format('MMMM YYYY')}
        icon='truck'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
              {alert.buyer.name}
            </Link>
            {' accrued '}
            <strong className='u-colorRed'>
              {alert.value.total.formatMoney()}
            </strong> {' '}
            in shipping fees from {alert.value.supplier_name ? alert.value.supplier_name : 'all suppliers'}
            {' '} in {moment(alert.date).format('MMMM')}
          </div>
        )}
        content={(
          <Table
            actions={
              <div className='u-paddingTop10'>
                <ColumnExportButton
                  filename='Vetcove_Shipping_Fees_Alert.csv'
                  data={alert.value.invoices}
                  columns={columns}
                >
                  Download
                </ColumnExportButton>
              </div>
            }
            size='small'
            columns={columns}
            data={alert.value.invoices}
          />
        )}
        {...this.props}
      />
    );
  }
}

ShippingFeesAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default ShippingFeesAlert;
